import { Component, Inject, inject, OnDestroy, OnInit } from "@angular/core";
import { HTMLPrintResult } from "src/app/services/print/print.service";
import { tap } from "rxjs/operators";
import { BehaviorSubject, Subscription } from "rxjs";
import { ReportDesignItemConfig } from "src/app/modules/bootstrap/modules/report/report-design-item";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "snt-report-designer-preview",
  templateUrl: "report-designer-preview.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerPreviewComponent implements OnInit, OnDestroy {
  printing: boolean = false;
  printingError: boolean = false;
  printResult: HTMLPrintResult | undefined;

  templateConfigChangesSubscription: Subscription | undefined;

  private reportService = inject(ReportService);

  constructor(
    @Inject("sidespace-data")
    private sideSpaceData: {
      templateConfigChange$: BehaviorSubject<ReportDesignItemConfig[]>;
    }
  ) {}

  ngOnInit(): void {
    this.templateConfigChangesSubscription = this.sideSpaceData
      .templateConfigChange$!.pipe(
        tap(() => {
          this.printing = true;
          this.printingError = false;
        }),
        tap(() => {
          this.printing = true;
        })
      )
      .subscribe(async (templateConfig) => {
        try {
          this.printResult = await this.reportService.templateToHTML(
            templateConfig,
            {},
            {
              renderer: "data",
              componentsRenderers: [],
              headerTitle: "",
              preview: true,
              onlyTextWithValue: false,
              useFakeTextData: true
            }
          );
        } catch (ex) {
          console.error(ex);
          this.printingError = true;
        } finally {
          this.printing = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.templateConfigChangesSubscription?.unsubscribe();
  }
}
